/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_EmptyInputs */

const en_fw_tpl_empty = /** @type {(inputs: Fw_Tpl_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No template matches this filter yet.`)
};

const id_fw_tpl_empty = /** @type {(inputs: Fw_Tpl_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada template yang cocok dengan filter ini.`)
};

/**
* | output |
* | --- |
* | "No template matches this filter yet." |
*
* @param {Fw_Tpl_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_empty = /** @type {((inputs?: Fw_Tpl_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_empty(inputs)
	return en_fw_tpl_empty(inputs)
});